import { authenticationConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: null,
    error: "",
  },
  action
) {
  switch (action.type) {
    case authenticationConstants.ORGANIZATION_REQUEST:
      return {
        data: null,
        isProgress: true,
      };
    case authenticationConstants.ORGANIZATION_SUCCESS: {
      const result = action.response.data;
      if (result?.app?.appCode) {
        localStorage.setItem("appCode", result?.app?.appCode);
      }
      if (result?.colorSchemeJson) {
        localStorage.setItem(
          "colorSchemeJson",
          JSON.stringify(result?.colorSchemeJson)
        );
      }

    localStorage.removeItem("defaultInsuranceId");
    if (result?.organizationOptionJson?.defaultInsuranceId) {
      localStorage.setItem(
        "defaultInsuranceId",
        result?.organizationOptionJson?.defaultInsuranceId
      );
    }
      

      return {
        ...state,
        data: action.response.data,
        isProgress: false,
      };
    }
    case authenticationConstants.ORGANIZATION_FAILURE:
      return {
        data: null,
        error: action.error,
        isProgress: false,
      };
    default:
      return state;
  }
}
